import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import VersionTable from 'components/Software/macOS/InstarVision/About/versionTable';
import NavButtons from 'components/Software/macOS/InstarVision/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "InstarVision v3 für macOS",
  "path": "/Software/macOS/InstarVision/About/",
  "dateChanged": "2018-01-25",
  "author": "Mike Polinowski",
  "excerpt": "Das InstarVision Surveillance Center ist eine IP-Kamera-Software, die 64 Kameras gleichzeitig unterstützen kann, einschließlich Netzwerkkameras, USB-Kameras mit Fernzugriff und Sekundärinstallationen der Software.",
  "image": "../P_SearchThumb_InstarVision_Windows.png",
  "social": "/images/Search/P_SearchThumb_InstarVision_Windows.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-Windows-InstarVision_white.webp",
  "chapter": "Software"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='InstarVision v3 für macOS' dateChanged='2018-01-25' author='Mike Polinowski' tag='INSTAR IP Camera' description='Das InstarVision Surveillance Center ist eine IP-Kamera-Software, die 64 Kameras gleichzeitig unterstützen kann, einschließlich Netzwerkkameras, USB-Kameras mit Fernzugriff und Sekundärinstallationen der Software.' image='/images/Search/P_SearchThumb_InstarVision_Windows.png' twitter='/images/Search/P_SearchThumb_InstarVision_Windows.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Software/macOS/InstarVision/About/' locationFR='/fr/Software/macOS/InstarVision/About/' crumbLabel="About" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/11ca083ea309a9741ea2d1d7e736289b/29114/Banner_en-InstarVision2-0_About.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "16.521739130434785%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAfUlEQVQI143HsQ6CMBhF4f9V5Pkc3CCyO9A61TgxmMCruLiSCMYXcHGhlaY05JjA4Ga4yZebI0wBBgtDD+GzvLdAZO2MMWT7HKJHVOPQd49+RHT3o7oR1Ya/ijZwfE7kB02621I0FpHyhVzeSO2Qqkcqu6jXciSnK5vzbe4v4+TA/ywGryoAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/11ca083ea309a9741ea2d1d7e736289b/e4706/Banner_en-InstarVision2-0_About.avif 230w", "/de/static/11ca083ea309a9741ea2d1d7e736289b/d1af7/Banner_en-InstarVision2-0_About.avif 460w", "/de/static/11ca083ea309a9741ea2d1d7e736289b/7f308/Banner_en-InstarVision2-0_About.avif 920w", "/de/static/11ca083ea309a9741ea2d1d7e736289b/e1c99/Banner_en-InstarVision2-0_About.avif 1380w", "/de/static/11ca083ea309a9741ea2d1d7e736289b/76ea5/Banner_en-InstarVision2-0_About.avif 1840w", "/de/static/11ca083ea309a9741ea2d1d7e736289b/f696c/Banner_en-InstarVision2-0_About.avif 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/11ca083ea309a9741ea2d1d7e736289b/a0b58/Banner_en-InstarVision2-0_About.webp 230w", "/de/static/11ca083ea309a9741ea2d1d7e736289b/bc10c/Banner_en-InstarVision2-0_About.webp 460w", "/de/static/11ca083ea309a9741ea2d1d7e736289b/966d8/Banner_en-InstarVision2-0_About.webp 920w", "/de/static/11ca083ea309a9741ea2d1d7e736289b/445df/Banner_en-InstarVision2-0_About.webp 1380w", "/de/static/11ca083ea309a9741ea2d1d7e736289b/78de1/Banner_en-InstarVision2-0_About.webp 1840w", "/de/static/11ca083ea309a9741ea2d1d7e736289b/882b9/Banner_en-InstarVision2-0_About.webp 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/11ca083ea309a9741ea2d1d7e736289b/81c8e/Banner_en-InstarVision2-0_About.png 230w", "/de/static/11ca083ea309a9741ea2d1d7e736289b/08a84/Banner_en-InstarVision2-0_About.png 460w", "/de/static/11ca083ea309a9741ea2d1d7e736289b/c0255/Banner_en-InstarVision2-0_About.png 920w", "/de/static/11ca083ea309a9741ea2d1d7e736289b/b1001/Banner_en-InstarVision2-0_About.png 1380w", "/de/static/11ca083ea309a9741ea2d1d7e736289b/161ec/Banner_en-InstarVision2-0_About.png 1840w", "/de/static/11ca083ea309a9741ea2d1d7e736289b/29114/Banner_en-InstarVision2-0_About.png 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/11ca083ea309a9741ea2d1d7e736289b/c0255/Banner_en-InstarVision2-0_About.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "über-instarvision-v3",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#%C3%BCber-instarvision-v3",
        "aria-label": "über instarvision v3 permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Über InstarVision v3`}</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/d2e7187464249370e48541810a10b82c/c929c/de_aboutIV.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "57.826086956521735%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAADUUlEQVQozx3M+1MSBgDAcf6rZZu1tRumZU5RUISBiq82tCbhcwKSpqSXKCZJU2c+gChDczo7zBdoqEfNVNLT5drGNM9Hamqe993qh+99fvsKTp2LITwqkfDIxE+eiUrizAUpwlg50bGJRFyMJywinrDzYk59LOKjEj6PTiY8KgFFppqFuTmcDgfLS0sIlC3LKJuDyO/OI7e9RNLwAnF9gCRLgO8a/KSZfyO5fgRJ3SgJdWOIrX6SrBPI7viQNk3wQ/MIDrsDs9lMb08PgqxyG7rOcSrczzE8mkXvnsc9sUD145do789R/mCaAkeAvHte8jonyb07iKbDS9F9P2WeVSr7fqe1tRWn04nDbkeg0WRjaazH0tRIlcVKv8fD27+DTAf83HP3Y2p5hMnxlJJGO8W1P5ORV4Sm0kxFiwuTa5gKm53aW7ewWCzYmpoQ5BuMdDzsxdbVTWNHN+3d/Tzuc/NL2x2s9l5k2lpUBhtp+ZUockpIytGRU15H3o0GRNfMJGtrGBsdZXzci8/nQ5B5pRB1filXSir4UV9Nru4m+soaZNkasgqrOJ9RSljSNU7HXebUBSXC1J8Qqgx8k6bjbIoeWUE9e3vv2Nra5OjwCEHnkykcnilcQ1O4h2f4dXQGt2eSYf8LBseeocjMQZWVQ2GxjrIyI0aDAV2pHq22GHFyClnqPN682WJtbZvd3R0EvsU1ni2tEwzt4l8M4Zv/kyfTQWb/+IfA4iq1NUbqTEW0NZmY9HSxMjtIYPwBPQ4rMfHxGI16Nt7C5iZ8+HCI4NXKKrOLK4TW13GPzHC5so2q5ofobndR1+6mWJNKRmocCfJEul21vF4ewuuxMuIqRCIVcV2nZu3fbUKhLXZ2thF09Axjc3loG5jC2P6UGK2VOI0ZUWEj6eXNnBUK+ezLr4kQS0lIUSJJUSGSy8jOUvKtRExapop3O9vs7+/xfv89goLqDrQl1eReb8bk9HF7YI6bTi83HF4qOoYIE8ZxWijinEhKdHI68oyrfJ+r5mqemq8uXkIklXF8fMzJyQmHBwcIBvyv6fMGGZxYwDcfwr+0wWRwnclXGww9/wthrILwiDjCImORKFJJz85Cma5CrFDyhTCSSwmJHB0dfZoe/D/8D6QeljS/7bZqAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/d2e7187464249370e48541810a10b82c/e4706/de_aboutIV.avif 230w", "/de/static/d2e7187464249370e48541810a10b82c/d1af7/de_aboutIV.avif 460w", "/de/static/d2e7187464249370e48541810a10b82c/7f308/de_aboutIV.avif 920w", "/de/static/d2e7187464249370e48541810a10b82c/203bb/de_aboutIV.avif 1218w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/d2e7187464249370e48541810a10b82c/a0b58/de_aboutIV.webp 230w", "/de/static/d2e7187464249370e48541810a10b82c/bc10c/de_aboutIV.webp 460w", "/de/static/d2e7187464249370e48541810a10b82c/966d8/de_aboutIV.webp 920w", "/de/static/d2e7187464249370e48541810a10b82c/491b1/de_aboutIV.webp 1218w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/d2e7187464249370e48541810a10b82c/81c8e/de_aboutIV.png 230w", "/de/static/d2e7187464249370e48541810a10b82c/08a84/de_aboutIV.png 460w", "/de/static/d2e7187464249370e48541810a10b82c/c0255/de_aboutIV.png 920w", "/de/static/d2e7187464249370e48541810a10b82c/c929c/de_aboutIV.png 1218w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/d2e7187464249370e48541810a10b82c/c0255/de_aboutIV.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <VersionTable mdxType="VersionTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      